import { render } from "./ContactList.vue?vue&type=template&id=6b4b0c35&scoped=true"
import script from "./ContactList.vue?vue&type=script&lang=js"
export * from "./ContactList.vue?vue&type=script&lang=js"

import "./ContactList.vue?vue&type=style&index=0&id=6b4b0c35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4b0c35"]])

export default __exports__